import {
  type TeamExternalIntegration,
  type ResponseBodyEvaluation,
  type EndpointResponse
} from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import {
  ENDPOINT_URLS,
  NEWRELIC_ALERTS_INCIDENTS_PATH
} from 'utils/third-party'

export const NEW_RELIC_INTEGRATION_URL = `${ENDPOINT_URLS.newrelic}${NEWRELIC_ALERTS_INCIDENTS_PATH}`

export const newRelicStatusCheckIntegration: TeamExternalIntegration = {
  name: 'New Relic',
  type: IntegrationType.Newrelic,
  authUrl: NEW_RELIC_INTEGRATION_URL,
  isPrivateNetworkIntegration: false,
  headers: [{ key: 'X-Api-Key', value: '', label: 'API Key' }],
  url: ENDPOINT_URLS.newrelic,
  sortIndex: 2
}

export const newRelicRegex = new RegExp(
  '^https:\\/\\/api.newrelic.com\\/v\\d/(alerts_incidents|alerts_violations|applications)(\\/.+\\.json|\\.json)'
)

export const convertToNewRelicUrl = (url: string): string | undefined => {
  return newRelicRegex.test(url) ? url : undefined
}

export const computeNewRelicResponseBodyEvaluationConfiguration = (
  url: string
): ResponseBodyEvaluation => {
  const regExpExecArray = newRelicRegex.exec(url)
  const newRelicEntity = regExpExecArray?.[1]
  const isEntityDetailsRequest = regExpExecArray?.[2]?.indexOf('/') !== -1

  switch (newRelicEntity) {
    case 'alerts_incidents':
      return {
        predicates: [
          {
            jpQuery: '.incidents.length()',
            type: 'Number',
            comparator: 'EQU',
            rValue: '0'
          }
        ],
        op: 'AND'
      } as ResponseBodyEvaluation
    case 'alerts_violations':
      return {
        predicates: [
          {
            jpQuery: '.violations.length()',
            type: 'Number',
            comparator: 'EQU',
            rValue: '0'
          }
        ],
        op: 'AND'
      } as ResponseBodyEvaluation
  }

  if (isEntityDetailsRequest && newRelicEntity === 'applications') {
    return {
      predicates: [
        {
          jpQuery: '.application.health_status',
          type: 'String',
          comparator: 'EQU',
          rValue: 'green'
        }
      ],
      op: 'AND'
    } as ResponseBodyEvaluation
  }

  return {
    predicates: [],
    op: 'AND'
  } as ResponseBodyEvaluation
}

export function getNewRelicApplicationName(
  testEndpointResponse: EndpointResponse,
  integration: TeamExternalIntegration
): string | undefined {
  if (integration.url?.includes('applications'))
    return JSON.parse(testEndpointResponse?.responseBody)?.application?.name
}
